import templateUrl from './model-state-errors.component.html';

/**
 * A component that displays and breaks down any model state errors in
 * the given input model state.
 */
export const ModelStateErrorsComponent = {
    templateUrl,
    bindings: {
        /**
         * The model state object, which represents the model errors as an array
         * of values for each key in the form. Considered immutable.
         */
        modelState: "<",
        close: "&onClose"
    },
    controller: class ModelStateErrorsComponent {
        $onChanges(changesObj) {
            if (changesObj.modelState) {
                if (!this.modelState) {
                    this.errorFields = [];
                } else {
                    this.errorFields = Object.keys(this.modelState).map(key => ({
                        fieldName: key,
                        values: this.modelState[key]
                    }));
                }
            }
        }
    }
}
